module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('h2', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocchac"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "toccha"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_vm._v("Overview of the South-West Pacific Area in 1942 and the Strategic Importance of Papua")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 1:")]), _vm._v(" Strategic overview of the Pacific War, 1941–1942")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map2"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 2:")]), _vm._v(" The Solomon Islands and Bismarck Archipelago, 1942–1943")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map3"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 3:")]), _vm._v(" The Papuan Campaign, July 1942–January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map4"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 4:")]), _vm._v(" MacArthur’s counter-offensive against the Buna–Giruwa–Sanananda–Gona Front, November 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocchac"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "toccha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terrain, Weaponry and Fortifications")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02#map5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 5:")]), _vm._v(" Allied combat on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warren")]), _vm._v(" Force Front, 18–28 December 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocchac"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h2', {
    staticClass: "toccha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commanders and Combatants")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocchac"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('h2', {
    staticClass: "toccha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Allied Attacks on Buna, 16 November 1942 to 22 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04#map6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("Map 6:")]), _vm._v(" Combat on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urbana")]), _vm._v(" Force Front, 18–28 December 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocchac"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('h2', {
    staticClass: "toccha"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Allied Attacks on Gona, Sanananda, and Giruwa")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_References",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0